import LogoutForm from "../../components/monaliza/authentication/LogoutForm";

const Logout = () => {


  return (
    <>
      <LogoutForm/>
    </>
  );
};

export default Logout;
